"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiSelect = void 0;
var react_1 = require("react");
var hooks_1 = require("../hooks");
var useUniqueId_1 = require("../hooks/useUniqueId");
var MultiSelect_1 = require("./MultiSelect");
var useMultiSelect = function (_a) {
    var _b = _a === void 0 ? {} : _a, defaultSelected = _b.defaultSelected, payload = _b.payload;
    var id = (0, useUniqueId_1.useUniqueId)();
    var ref = (0, react_1.useRef)(null);
    var _c = (0, react_1.useContext)(MultiSelect_1.MultiSelectContext), selection = _c.selection, __select__ = _c.select, __deselect__ = _c.deselect, isWrapped = _c.isWrapped;
    // Handle default selections
    (0, react_1.useEffect)(function () {
        if (defaultSelected)
            __select__(id.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultSelected, id]);
    var select = (0, react_1.useCallback)(function () {
        return __select__(id.current, payload);
    }, [__select__, id, payload]);
    var deselect = (0, react_1.useCallback)(function () {
        __deselect__(id.current, payload);
    }, [__deselect__, id, payload]);
    var selected = (0, react_1.useMemo)(function () {
        return !!selection.find(function (item) { return item.id === id.current; });
    }, [id, selection]);
    var onMouseDown = function (event) {
        if (selected && event.metaKey) {
            deselect();
            return;
        }
        select();
    };
    var handleClickOutside = (0, react_1.useCallback)(function (event) {
        if (!selected || event.metaKey)
            return;
        deselect();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]);
    (0, hooks_1.useClickOutside)({
        ref: ref,
        type: "mousedown",
        onClickOutside: handleClickOutside,
        when: selected,
    });
    return {
        deselect: deselect,
        id: id.current,
        isWrapped: isWrapped,
        onMouseDown: onMouseDown,
        ref: ref,
        select: select,
        selected: selected,
        selection: selection,
    };
};
exports.useMultiSelect = useMultiSelect;
//# sourceMappingURL=useMultiSelect.js.map